import { Github, Instagram } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import { useAuth } from '../context/AuthContext';

export default function Hero() {
  const { t } = useLanguage();
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleDecoClick = () => {
    if (user) {
      navigate('/privat');
    } else {
      navigate('/login');
    }
  };

  return (
    <section className="hero-v3">
      <div className="hero-v3-grid" />
      <div className="hero-grain" />

      {/* Versteckter Zugang — kein cursor pointer, kein Hinweis */}
      <div
        className="hero-v3-deco"
        aria-hidden="true"
        onClick={handleDecoClick}
        style={{ cursor: 'default' }}
      >
        &lt;/&gt;
      </div>

      <div className="hero-v3-inner">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          <div className="hero-available" style={{ marginBottom: '32px' }}>
            <span className="available-dot" />
            {t('hero.available')}
          </div>

          <p className="hero-eyebrow" style={{ marginBottom: '20px' }}>
            {t('hero.title')}
          </p>

          <h1 className="hero-v3-h1">
            <span className="h1-normal">{t('hero.name1')}</span>
            <span className="h1-outline">{t('hero.name2')}</span>
            <span className="h1-accent">{t('hero.name3')}</span>
          </h1>

          <p className="hero-desc hero-desc-v3">
            {t('hero.subtitle')}
          </p>

          <div className="hero-btns" style={{ justifyContent: 'flex-start' }}>
            <a href="https://github.com/LinoPL19" className="btn btn-outline" target="_blank" rel="noopener noreferrer">
              <Github size={14} /> GitHub
            </a>
            <a href="https://instagram.com/LinoPL19" className="btn btn-outline" target="_blank" rel="noopener noreferrer">
              <Instagram size={14} /> Instagram
            </a>
            <Link to="/contact" className="btn btn-fill">{t('nav.contact')} →</Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
